/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetInfrastructureNearbyBlockRequest,
  TGetInfrastructureNearbyBlockModel,
  IMappers,
  TGetInfrastructureNearbyBlockResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IInfrastructureResponse } from '../../entities/infrastructure_nearby/InfrastructureResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetInfrastructureNearbyBlockModel(
  parameters: IGetInfrastructureNearbyBlockRequest,
): TGetInfrastructureNearbyBlockModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'price-estimator',
    pathApi: '/v2/get-infrastructure-nearby-block/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetInfrastructureNearbyBlockOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetInfrastructureNearbyBlockRequest;
}

export async function fetchGetInfrastructureNearbyBlock<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetInfrastructureNearbyBlockOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetInfrastructureNearbyBlockResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetInfrastructureNearbyBlockModel(parameters),
    config,
  )) as FetchResponse<TGetInfrastructureNearbyBlockResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IInfrastructureResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetInfrastructureNearbyBlockResponse>;
}
